<template lang="pug">
  validation-provider(:name="fieldNameForMessage" v-slot="validator" :rules="rules" slim)
    b-field.control.is-expanded(
      :label-position="labelPosition"
      :type="{'is-danger': hasError(validator)}"
      :message="getMessageOrError(validator)"
    )
      template(v-slot:label v-if="label")
        span(:class="!isRequired || innerValue ? '' : 'has-text-danger'")
          | {{label}}
          span(v-if="isRequired") *

      component(:is="componentName" :type="type" v-bind="$attrs" v-on="$listeners")
        slot
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
  name: 'ui-field',

  components: {
    ValidationProvider,
  },

  props: {
    type: {
      default: () => 'text',
    },
    labelPosition: {
      default: () => 'default',
    },
    error: String,
    message: String,
    rules: String,
    label: String,
  },

  computed: {
    componentName() {
      switch (this.type) {
        case 'switch':
          return 'b-switch';
        case 'select':
          return 'b-select';
      }
      return 'b-input';
    },

    innerValue: {
      get() {
        return this.$attrs.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },

    isRequired() {
      return this.rules ? this.rules.indexOf('required') != -1 : false;
    },

    fieldNameForMessage() {
      let fieldName = this.label || this.$attrs.placeholder;
      return fieldName ? `"${fieldName}"` : ' ';
    },
  },

  methods: {
    getMessageOrError(validator) {
      return this.error ? this.error : validator.errors[0] ? validator.errors[0] : this.message;
    },

    hasError(validator) {
      return this.error || (validator && validator.failed);
    },
  },
};
</script>
